/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable vue/no-parsing-error */
import Vue from 'vue';
import iView from 'iview';
import VueRouter from 'vue-router';
import { routers, otherRouter, appRouter } from './router';
import Vuex from 'vuex';
import Util from './libs/util';
import App from './App.vue';
import Cookies from 'js-cookie';
import 'iview/dist/styles/iview.css';

import VueI18n from 'vue-i18n';
import zhLocale from 'iview/src/locale/lang/zh-CN';
import enLocale from 'iview/src/locale/lang/en-US';
import zhTLocale from 'iview/src/locale/lang/zh-TW';
import mainOrderModule from '@/views/main-order-number/store';
import couponStoreModule from './stores/coupon.module';
import dataStoreModule from './stores/data.module';
import userStoreModule from './stores/user.module';
import createOrderModule from '@/views/create-detail-order/store';
import moment from 'moment';
import env from './config/config';
import util from '@/libs/util';
import {xinjiyuanMenuList, defaultMenuList} from './api/menuList';
import GoEasy from 'goeasy';


var goeasyKey = ''
if(location.href.indexOf('duckbillscm.com')>0 || location.href.indexOf('yazuishou.com')>0){
    goeasyKey = 'BC-245258adae43407b961c4facf38d9671'
}else{
    goeasyKey = 'BC-32c477099c6f4745815b3c39a80892b8'
}

const goEasy = GoEasy.getInstance({
    host:'hangzhou.goeasy.io', //新加坡host：singapore.goeasy.io
    appkey: goeasyKey, //替换为您的应用appkey
    modules: ['pubsub']
});
Vue.prototype.goEasy = goEasy;
// 清除缓存
try {
    const openedPageList = JSON.parse(localStorage.getItem('pageOpenedList') || '[]');
    const openedPageNameList = openedPageList.map(v => v.name);
    const routeName = 'create-history-order_index';

    openedPageList.forEach(item => {
        if (item.name === 'home_index') {
            item.title = '订单中心';
        }
        if (item.title === '日账单查询') {
            item.title = '所有费用';
        }
    });
    if (openedPageNameList.includes(routeName)) {
        localStorage.setItem('cachePage', '[]');
        localStorage.setItem('pageOpenedList', JSON.stringify(openedPageList.filter(v => v.name !== routeName)));
        location.pathname = '/home';
    } else {
        localStorage.setItem('pageOpenedList', JSON.stringify(openedPageList));
    }
} catch (error) {
    console.log('缓存清除失败', error);
}

Vue.prototype.$moment = moment;

const testConfigUrl = [
    'qa.yazuishou',
    'qa.duckbillscm.com',
    'vpc.duckbillscm.com',
    'vpc.yazuishou.com',
    'uatm.yazuishou.com'
];
if (
  window.location.origin.indexOf('yazuishou.com') > 0 ||
  window.location.origin.indexOf('duckbillscm.com') > 0
) {
    (function () {
        var baiduKey = '';
    // 测试环境，禁止百度统计
        testConfigUrl.forEach(item => {
            if (window.location.href.indexOf(item) > 0) {

            }
        });
        if (window.location.origin.indexOf('yazuishou.com') > 0) {
            baiduKey = 'b1790f481a9a2b371181dff8562bcab5';
        }
        if (window.location.origin.indexOf('duckbillscm.com') > 0) {
            baiduKey = '22ee7ac4fa5b3244769a46b6b42536b7';
        }
        var hm = document.createElement('script');
        hm.src = 'https://hm.baidu.com/hm.js?' + baiduKey;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm, s);
    })();

  // 监控包
    // var fundebug = require('fundebug-javascript');
    // fundebug.apikey =
    // 'f3ecf8b359192db80f659f74cc6d296370c9b52fb80e647e2548c24458bf8f60';
    // fundebug.silentResource = true; // 禁止监控静态资源加载错误
    // fundebug.silentDev = true; // 禁止开发环境监控
    // Vue.config.errorHandler = function (err, vm, info) {
    //     if (vm) {
    //         var componentName = formatComponentName(vm);
    //         var propsData = vm.$options && vm.$options.propsData;
    //         fundebug.notifyError(err, {
    //             metaData: {
    //                 componentName: componentName,
    //                 propsData: propsData,
    //                 info: info
    //             }
    //         });
    //     } else {
    //         fundebug.notifyError(err);
    //     }
    // };
}

// 有fundebug不用了
// 获取异常

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(iView);

// errhander监控配置
// function formatComponentName (vm) {
//     if (vm.$root === vm) return 'root';
//     var name = vm._isVue
//     ? (vm.$options && vm.$options.name) ||
//       (vm.$options && vm.$options._componentTag)
//     : vm.name;
//     return (
//     (name ? 'component <' + name + '>' : 'anonymous component') +
//     (vm._isVue && vm.$options && vm.$options.__file
//       ? ' at ' + (vm.$options && vm.$options.__file)
//       : '')
//     );
// }

// 自动设置语言
const navLang = navigator.language;
const localLang = navLang === 'zh-CN' || navLang === 'en-US' ? navLang : false;
const lang = window.localStorage.lang || localLang || 'zh-CN';

Vue.config.lang = lang;

// 多语言配置
const mergeZH = Object.assign(zhLocale, {});
const mergeEN = Object.assign(enLocale, {});
const mergeTW = Object.assign(zhTLocale, {});
Vue.locale('zh-CN', mergeZH);
Vue.locale('en-US', mergeEN);
Vue.locale('zh-TW', mergeTW);

// 路由配置
const RouterConfig = {
    mode: 'history',
    routes: routers,
    linkActiveClass: 'active'
};

export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
    store.commit('user/save', {
        showBlackListModal: false
    });
    iView.LoadingBar.start();
    Util.title(to.meta.title);
    if (Cookies.get('locking') === '1' && to.name !== 'locking') {
    // 判断当前是否是锁定状态
        next(false);
        router.replace({
            name: 'locking'
        });
    } else if (Cookies.get('locking') === '0' && to.name === 'locking') {
        next(false);
    } else {
        // debugger
        let accessList = defaultMenuList;
        if (env.env == 'development') {
            // 测试环境 20368
            if (Cookies.get('userId') == 20368  || Cookies.get('userId') == 50660 || Cookies.get('userId') == 48855) {
                accessList.unshift('CROSS-BORDER-LOGISTICS');
            }
            if (Cookies.get('userId') != 1316674) {
                accessList.unshift('MAIN_QUERY_CHARGE');
            }
            
        } else {
            // if (Cookies.get('userId') == 47628 ||   
            // Cookies.get('userId') == 51134 || 
            if (Cookies.get('userId') == 47844 || 
            Cookies.get('userId') == 50950 || 
            Cookies.get('userId') == 51267 ||
            Cookies.get('userId') == 52736 ||   //杭州中策物流有限公司
            Cookies.get('userId') == 48684    //上海亭斯国际货运代理有限公司
            ) {
                accessList.unshift('CROSS-BORDER-LOGISTICS');
            }
            // 客户明光三友电力科技有限公司 客户端系统屏蔽查运价功能
            if (Cookies.get('userId') != 1036101) {
                accessList.unshift('MAIN_QUERY_CHARGE');
            }
        }
        if (!Cookies.get('user') && to.name !== 'index') {
      // RouterConfig.routes[17].children.forEach(k =>{

      // })
            const noLoginPageList = [
                'new-index',
                'news',
                'about',
                'articles',
                'truck-location',
                'mission-hall',
                'data-complet',
                'data-topart',
                'default',
                'query-charge-new',
                'map-test',
                'register',
                'register-supplement',
                'register-personal',
                'register-company',
                'courier-query',
                'login',
                'reset',
                'LCL',
                'server-product',
                'service-advisory',
                'linkApplyQuota'
            ];
            const toLoginPageList = [
                'place-order-pre',
                'main-query-charge_index'
            ];

            const peakSeasonPageList = [
                'excess',
                'peakSeasonQuota'
            ]

            if (noLoginPageList.some(v => to.name === v)) {
                next();
            } else if (toLoginPageList.some(v => to.name === v) && to.query.priceSnapshotId) {
                next({
                    name: 'login',
                    params: {
                        priceSnapshotId: to.query.priceSnapshotId,
                        priceType: to.query.priceType,
                        transportTypeId: to.query.transportTypeId,
                        subTransportTypeName: to.query.subTransportTypeName
                    }
                });
            } else if (peakSeasonPageList.some(v => to.name === v)) {
                next({
                    name: 'login',
                    params: {
                        type:"peakseason",
                        o:to.query.o,
                        ai:to.query.ai,
                    }
                });
            }else{
                next({ name: 'index' });
            }
        } else if (
            Cookies.get('user') &&
            Cookies.get('companyName') == 'undefined' &&
            to.query.priceSnapshotId &&
            to.name !== 'index'
          ) {
            const toLoginPageList = [
                'place-order-pre',
                'main-query-charge_index'
            ];
            if (toLoginPageList.some(v => to.name === v) && to.query.priceSnapshotId) {
                // next()
                next({name: 'query-charge-new', params: {priceSnapshotId: to.query.priceSnapshotId}});
                // next({path: '/query-charge-new', query: {priceSnapshotId: to.query.priceSnapshotId}})
            }
        } else if (
      Cookies.get('user') &&
      Cookies.get('companyName') == 'undefined' &&
      to.name !== 'index'
    ) {
            const noLoginPageList = [
                'home_index',
                'news',
                'about',
                'articles',
                'truck-location',
                'mission-hall',
                'default',
                'query-charge-new',
                'map-test',
                'register',
                'register-supplement',
                'register-company',
                'exception-fee',
                'courier-query',
                'login',
                'personal-center',
                'reset',
                'LCL',
                'server-product',
                'service-advisory',
                'linkApplyQuota'
            ];
            const toLoginPageList = [
                'main-query-charge_index'
            ];
            if (noLoginPageList.some(v => to.name === v)) {
                next();
            } else if (toLoginPageList.some(v => to.name === v)) {
                next({
                    name: 'main-query-charge'
                });
            } else {
                next({ name: 'index' });
            }
        } else if (Cookies.get('user') && (to.name === 'login' || to.name === 'register' || to.name === 'register-supplement' || to.name === 'register-personal')) {
            next({ name: 'index' });
        } else if (Cookies.get('user') && Cookies.get('access') === 'unsignedCustomer' && to.name === 'create-order') {
            next({ name: 'home' });
        } else if (Cookies.get('user') && to.name === 'index') {
            // 判断是否已经登录且前往的是登录页
            Util.title();
            next();
        } else {
            if (Util.getRouterObjByName([otherRouter, ...appRouter], to.name).access !== undefined) {
                let accessList = defaultMenuList;
                if (Cookies.get('isVest') === 'true') {
                    Cookies.set('authorities', xinjiyuanMenuList.join(','));
                    accessList = xinjiyuanMenuList;
                }
                if (Cookies.get('authorities')) {
                    accessList.push('CHILD_CUSTOMER');
                }
                // 正式环境
                // if (Cookies.get('userId') == 47628 || Cookies.get('userId') == 47844) {
                //     accessList.unshift('CROSS-BORDER-LOGISTICS');
                // }

                // 测试环境 20368
                // if (Cookies.get('userId') == 20368  || Cookies.get('userId') == 50660) {
                //     accessList.unshift('CROSS-BORDER-LOGISTICS');
                // }

                // 判断用户是否有权限访问当前页
                if (Util.showThisRoute(accessList, Util.getRouterObjByName([otherRouter, ...appRouter], to.name).access)) {
                    Util.toDefaultPage([otherRouter, ...appRouter], to.name, router, next); // 如果在地址栏输入的是一级菜单则默认打开其第一个二级菜单的页面
                } else {
                    router.replace({ name: 'error_401' });
                    next();
                }
            } else {
                if (to.name === 'exception-fee') {
                    next({ name: 'index' });
                } else {
                    Util.toDefaultPage([otherRouter, ...appRouter], to.name, router, next);
                }
            }
        }
    }
    iView.LoadingBar.finish();
});

router.afterEach((from, to) => {
    // 记录 上一次的 router

    // 记录进入下单页面的路由栈
    let stack = JSON.parse(sessionStorage.getItem('RouteStack') || '[]');
    if (from) {
        stack.push({
            path: from.path,
            name: from.name,
            params: from.params,
            query: from.query
        });
        sessionStorage.setItem('RouteStack', JSON.stringify(stack));
    }
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});
// 状态管理
export const store = new Vuex.Store({
    state: {
        routers: [otherRouter, ...appRouter],
        menuList: [],
        canEvaluate: false,
        evaluateNumber: 0,
        tagsList: [...otherRouter.children],
        pageOpenedList: [],
        currentPageName: '',
        currentPath: [], // 面包屑数组
        openedSubmenuArr: [], // 要展开的菜单数组
        menuTheme: '', // 主题
        theme: '',
        cachePage: [],
        lang: '',
        isFullScreen: false,
        showChat: false,
        menuBadgeList: [], // 菜单小红点
        dontCache: [
            'text-editor',
            'place-order-pre',
            'place-order-index'
        ], // 在这里定义你不想要缓存的页面的name属性值(参见路由配置router.js)
        noChatPage: ['exception-fee'], // 不需要找客服按钮的页面
        declareParams: {} // 我的订单跳转报关
    },
    getters: {
        getMenuList: state => {
            return state.menuList;
        }
    },
    mutations: {
        setDeclareParams (state, params) {
            state.declareParams = params;
        },
        clearDeclareParams (state) {
            state.declareParams = {};
        },
        setTagsList (state, list) {
            state.tagsList.push(...list);
        },
        closePage (state, name) {
            state.cachePage.forEach((item, index) => {
                if (item === name) {
                    state.cachePage.splice(index, 1);
                }
            });
        },
        increateTag (state, tagObj) {
            if (!Util.oneOf(tagObj.name, state.dontCache)) {
                state.cachePage.push(tagObj.name);
                localStorage.cachePage = JSON.stringify(state.cachePage);
            }
            state.pageOpenedList.push(tagObj);
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
    /**
     * @desc 根据 name 更新 pageOpenedList 对象某一个
     * @param {*} state
     * @param {*} payload
     */
        updateTag (state, payload) {
            let { name, data } = payload;
            let res = state.pageOpenedList.map(v => {
                if (v.name !== name) {
                    return v;
                } else {
                    return {
                        ...v,
                        ...data,
                        name
                    };
                }
            });
            state.pageOpenedList = res;
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        initCachepage (state) {
            if (localStorage.cachePage) {
                state.cachePage = JSON.parse(localStorage.cachePage);
            }
        },
        removeTag (state, name) {
            let ele = document.querySelector('.main > .single-page-con');
            if (ele) ele.scrollTop = 0;

            state.pageOpenedList.map((item, index) => {
                if (item.name === name) {
                    state.pageOpenedList.splice(index, 1);
                }
            });
        },
        pageOpenedList (state, get) {
            let openedPage = state.pageOpenedList[get.index];
            if (get.argu) {
                openedPage.argu = get.argu;
            }
            if (get.query) {
                openedPage.query = get.query;
            }
            state.pageOpenedList.splice(get.index, 1, openedPage);
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        clearAllTags (state) {
            state.pageOpenedList.splice(1);
            router.push({
                name: 'home_index'
            });
            state.cachePage.length = 0;
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        clearOtherTags (state, vm) {
            let currentName = vm.$route.name;
            let currentIndex = 0;
            state.pageOpenedList.forEach((item, index) => {
                if (item.name === currentName) {
                    currentIndex = index;
                }
            });
            if (currentIndex === 0) {
                state.pageOpenedList.splice(1);
            } else {
                state.pageOpenedList.splice(currentIndex + 1);
                state.pageOpenedList.splice(1, currentIndex - 1);
            }
            let newCachepage = state.cachePage.filter(item => {
                return item === currentName;
            });
            state.cachePage = newCachepage;
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        setOpenedList (state) {
            state.pageOpenedList = localStorage.pageOpenedList
        ? JSON.parse(localStorage.pageOpenedList)
        : [otherRouter.children[0]];
        },
        setCurrentPath (state, pathArr) {
            state.currentPath = pathArr;
        },
        setCurrentPageName (state, name) {
            state.currentPageName = name;
        },
        addOpenSubmenu (state, name) {
            let hasThisName = false;
            let isEmpty = false;
            if (name.length === 0) {
                isEmpty = true;
            }
            if (state.openedSubmenuArr.indexOf(name) > -1) {
                hasThisName = true;
            }
            if (!hasThisName && !isEmpty) {
                state.openedSubmenuArr.push(name);
            }
        },
        clearOpenedSubmenu (state) {
            state.openedSubmenuArr.length = 0;
        },
        changeMenuTheme (state, theme) {
            state.menuTheme = theme;
        },
        changeMainTheme (state, mainTheme) {
            state.theme = mainTheme;
        },
        lock (state) {
            Cookies.set('locking', '1');
        },
        unlock (state) {
            Cookies.set('locking', '0');
        },
        setMenuList (state, menulist) {
            state.menuList = menulist;
        },
        updateMenulist (state) {
            let accessList = defaultMenuList;
            if (Cookies.get('isVest') === 'true') {
                Cookies.set('authorities', xinjiyuanMenuList.join(','));
                accessList = xinjiyuanMenuList;
            }
            if (Cookies.get('authorities')) {
                accessList.push('CHILD_CUSTOMER');
            }
            let menuList = [];
            appRouter.forEach((item, index) => {
                if (item.children.length === 1) {
                    if (Util.showThisRoute(accessList, item.children[0].access)) {
                        menuList.push(item);
                    }
                } else {
                    let childrenArr = [];
                    childrenArr = item.children.filter(child => {
                        if (child.access !== undefined) {
                            if (Util.showThisRoute(accessList, child.access)) {
                                return child;
                            }
                        } else {
                            return child;
                        }
                    });
                    if (childrenArr.length !== 0) {
                        let len = menuList.push(item);
                        menuList[len - 1].children = childrenArr;
                    }
                }
            });

            state.menuList = menuList;
        },
        setAvator (state, path) {
            localStorage.avatorImgPath = path;
        },
        switchLang (state, lang) {
            state.lang = lang;
            Vue.config.lang = lang;
        },
        handleFullScreen (state) {
            let main = document.body;
            if (state.isFullScreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (main.requestFullscreen) {
                    main.requestFullscreen();
                } else if (main.mozRequestFullScreen) {
                    main.mozRequestFullScreen();
                } else if (main.webkitRequestFullScreen) {
                    main.webkitRequestFullScreen();
                } else if (main.msRequestFullscreen) {
                    main.msRequestFullscreen();
                }
            }
        },
        changeFullScreenState (state) {
            state.isFullScreen = !state.isFullScreen;
        },
        changeMenuBadge (state, menuBadgeList) {
            state.menuBadgeList = [...menuBadgeList];
        }
    },
    actions: {},
    modules: {
        mainOrderNumber: mainOrderModule, // 主提单号的store  mainOrderNumber
        coupon: couponStoreModule,
        createOrder: createOrderModule,
        user: userStoreModule,
        data: dataStoreModule
    }
});

export let app = new Vue({
    el: '#app',
    router: router,
    store: store,
    render: h => h(App),
    data: {
        currentPageName: ''
    },
    mounted () {
        this.currentPageName = this.$route.name;
    // 显示打开的页面的列表
        this.$store.commit('setOpenedList');
        this.$store.commit('initCachepage');
    // 权限菜单过滤相关
        this.$store.commit('updateMenulist');
    // 全屏相关
        document.addEventListener('fullscreenchange', () => {
            this.$store.commit('changeFullScreenState');
        });
        document.addEventListener('mozfullscreenchange', () => {
            this.$store.commit('changeFullScreenState');
        });
        document.addEventListener('webkitfullscreenchange', () => {
            this.$store.commit('changeFullScreenState');
        });
        document.addEventListener('msfullscreenchange', () => {
            this.$store.commit('changeFullScreenState');
        });
    },
    created () {
        let tagsList = [];
        appRouter.map(item => {
            if (item.children.length <= 1) {
                tagsList.push(item.children[0]);
            } else {
                tagsList.push(...item.children);
            }
        });
        this.$store.commit('setTagsList', tagsList);
    },
    watch: {
        $route (val, olval) {
            var router = val.path.split('/')[1];
            if (this.$store.state.noChatPage.indexOf(router) >= 0) {
                this.$store.state.showChat = false;
            } else {
                this.$store.state.showChat = false;
            }
        }
    }
});



// WEBPACK FOOTER //
// ./src/main.js